var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6326 94.4375L54.0876 93.7275L48.5251 71.475L26.2701 65.9125L25.5601 60.3675L91.5626 24.3675L95.6326 28.4375L59.6326 94.4375ZM35.1826 61.955L51.7276 66.09L53.9101 68.2725L58.0451 84.8175L85.4801 34.52L35.1826 61.955Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentPosition);
export default __webpack_public_path__ + "static/media/CurrentPosition.628d95bf.svg";
export { ForwardRef as ReactComponent };